import { render, staticRenderFns } from "./customer-delivery-address-list.vue?vue&type=template&id=21d41b26"
import script from "./customer-delivery-address-list.vue?vue&type=script&lang=js"
export * from "./customer-delivery-address-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports